const COUNTRIES = "COUNTRIES";
const STATES = "STATES";
const OPERATIONTIMEZONE = "OPERATIONTIMEZONE";

const lookupAction = { COUNTRIES, STATES, OPERATIONTIMEZONE };

export default lookupAction;
